import { Box, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ReactComponent as Pencil } from 'src/assets/svg/pencil.svg';
import { BookingDetailsDialog } from 'src/features/booking-details-dialog';
import { selectUserIsOccupantFlow } from 'src/store/slices/user-slice';

import { BookingDetailsContent } from './booking-details-content';
import { styles } from './styles';

export const YourBookingDetails: FC = () => {
    const { t } = useTranslation();
    const isOccupantFlow = useSelector(selectUserIsOccupantFlow);

    useEffect(() => {
        window.dataLayer.push({
            event: 'booking_details',
        });
    }, []);

    const [isEditOpen, setIsEditOpen] = useState<boolean>(false);

    const handleIsEditOpen = () => {
        setIsEditOpen((prev) => !prev);
    };

    return (
        <Box css={styles.wrapper}>
            <Box css={styles.header}>
                <Typography css={styles.title} variant="h2">
                    {t('your_details_booking_details')}
                </Typography>
                {!isOccupantFlow && <Pencil css={styles.icon} onClick={handleIsEditOpen} />}
            </Box>
            <BookingDetailsContent />
            <BookingDetailsDialog isOpen={isEditOpen} handleIsOpen={handleIsEditOpen} />
        </Box>
    );
};
